export default function baseStyles(colorLight, colorDark) {
  return {
    bar: {
      display: 'flex',
      backgroundColor: colorLight,
      borderTop: `2px solid ${colorDark}`,
      borderBottom: `2px solid ${colorDark}`,
      padding: '0.5rem',
      margin: '1rem -1rem 1rem',
    },
    icon: {
      marginRight: '1rem',
      height: '22.5px',
    },
  };
}
